import {
  ENGAGEMENT,
  LEAD_GENERATION,
  REACH,
  TRAFFIC,
  VIDEO_VIEWS,
  WEB_CONVERSIONS
} from '../../../../../../../constants/campaigns'

import FrequencyStep from './FrequencyStep'
import OptimizationGoalAndBiddingStep from './OptimizationGoalAndBiddingStep'
import GoalsWithPixelAndEventStep from './GoalsWithPixelAndEventStep'

export const getCampaignObjectiveBasedStep = ({
  campaignObjective,
  showBidField,
  shouldPopulateExistingValues,
  isBidTypeNoBidPopulated,
  showOnlyLineItemStep
}) => {
  if (showOnlyLineItemStep) {
    return {
      component: null,
      show: false
    }
  }

  switch (campaignObjective.toLowerCase()) {
    case REACH:
      return {
        component: <FrequencyStep campaignObjective={campaignObjective} showBidField={showBidField} />,
        show: true
      }
    case TRAFFIC:
    case VIDEO_VIEWS:
    case ENGAGEMENT:
      return {
        component: (
          <OptimizationGoalAndBiddingStep
            campaignObjective={campaignObjective}
            showBidField={showBidField}
            shouldPopulateExistingValues={shouldPopulateExistingValues}
          />
        ),
        show: !(shouldPopulateExistingValues && isBidTypeNoBidPopulated)
      }
    case LEAD_GENERATION:
    case WEB_CONVERSIONS:
      return {
        component: (
          <GoalsWithPixelAndEventStep
            campaignObjective={campaignObjective}
            showBidField={showBidField}
            shouldPopulateExistingValues={shouldPopulateExistingValues}
          />
        ),
        show: !(shouldPopulateExistingValues && isBidTypeNoBidPopulated)
      }
    default:
      return {
        component: null,
        show: false
      }
  }
}
